import React from 'react';
import { connect } from 'react-redux';

import { Loader } from '../components/common';
import { fetchExperiments, setExperiments } from '../experiments/experiments';
import { checkSession } from '../redux/actions/login';
import { errorLogger } from '../utils/error-logger/error-logger';
import { fedopsLogger } from '../utils/fedopsLogger/fedopsLogger';
import {
  start as startNavigation,
  stop as stopNavigation,
} from '../utils/navigation';
import { BI_ERRORS } from '../utils/statistics/bi-error-logger/bi-errors';

import styles from './router-bootstrap.scss';

interface RouterBootstrapContainerDispatchProps {
  checkSession(): void;
}

interface RouterBootstrapContainerOwnProps {
  children(): React.ReactNode;
}

interface State {
  isReady: boolean;
}

type RouterBootstrapContainerProps = RouterBootstrapContainerDispatchProps &
  RouterBootstrapContainerOwnProps;

class RouterBootstrap extends React.Component<
  RouterBootstrapContainerProps,
  State
> {
  public state: State;

  constructor(props: RouterBootstrapContainerProps) {
    super(props);

    this.state = {
      isReady: false,
    };
  }

  public logAppLoaded() {
    window.requestAnimationFrame(() => {
      fedopsLogger.appLoaded();
    });
  }

  public componentDidMount() {
    const prerequirementsPromise = Promise.all([
      fetchExperiments().then(setExperiments, (reason) => {
        errorLogger.logError({
          errorDescription: BI_ERRORS.init.getExperiments,
          otherParams: { reason },
        });
        return Promise.reject(reason);
      }),
      this.props.checkSession(),
    ]);

    prerequirementsPromise
      .then(
        () => this.setState({ isReady: true }, () => this.startNavigation()),
        () => this.setState({ isReady: true }, () => this.startNavigation()),
      )
      .catch(() => {
        console.warn('Cannot fetch the general data from server.');
      });

    prerequirementsPromise.then(this.logAppLoaded, this.logAppLoaded);
  }

  public componentWillUnmount(): void {
    stopNavigation();
  }

  public startNavigation(): void {
    startNavigation();
  }

  public render() {
    if (!this.state.isReady) {
      return <Loader className={styles.loader} />;
    }

    return this.props.children();
  }
}

export const RouterBootstrapContainer = connect<
  null,
  RouterBootstrapContainerDispatchProps,
  RouterBootstrapContainerOwnProps
>(
  null,
  (dispatch): RouterBootstrapContainerDispatchProps => ({
    checkSession: () => {
      return dispatch<any>(checkSession());
    },
  }),
)(RouterBootstrap);
